<template>
    <div id="why" class="why">
        <div class="container">
            <CHeading class="text-center" section variant="2">
                <slot />
            </CHeading>

            <div class="why__items grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" :class="{ 'no-top': noTop }">
                <div
                    v-for="(item, index) in cols"
                    :key="index"
                    class="why__item"
                    :class="{
                        'exponentially-aligned': exponentiallyAlignedIcons,
                        'straignt-aligned': straightAlignedIcons,
                        'clickable': item.url
                    }"
                    @click="openUrl(item, openInNewWindow)"
                >
                    <div
                        class="why__wrapper"
                        :class="{
                            'squared': squared,
                            'variableHeight': variableHeight
                        }"
                    >
                        <div class="why__content">
                            <img :alt="item.alt" class="image" loading="lazy" :src="getImgUrl(item.img)" />
                            <div class="item-title" v-html="item.title"></div>
                            <p v-if="item.text" class="mt-4">
                                <span v-html="item.text"></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="$slots.bottom" class="text-center">
                <slot name="bottom" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CHeading from '@/components/ui/CHeading.vue'
import { useRouter } from 'vue-router'

export type FourColsWhyBlockItemType = {
    img: string
    alt: string
    title: string
    text?: string
    url?: string
}

export type FourColsWhyBlockItemsType = FourColsWhyBlockItemType[]

interface Props {
    cols: FourColsWhyBlockItemsType
    squared?: boolean
    exponentiallyAlignedIcons?: boolean
    variableHeight?: boolean
    straightAlignedIcons?: boolean
    noTop?: boolean
    openInNewWindow?: boolean
}

const props = defineProps<Props>()
const router = useRouter()

const getImgUrl = (imgLink: string) => {
    return `/images/${imgLink}`
}

const openUrl = (item: FourColsWhyBlockItemType, openInNewWindow: boolean | undefined) => {
    if (item.url && openInNewWindow && process.client) {
        const routeData = router.resolve(item.url)
        window.open(routeData.href, '_blank')
    }

    if (item.url && !openInNewWindow) {
        router.push(item.url)
    }
}
</script>

